import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Vessel } from '../../vessels.service';
import { Router } from '@angular/router';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatButtonModule } from '@angular/material/button';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { VesselServiceSpa } from 'src/app/generated/services/transportation/vessels/vesselSpa';

@Component({
  selector: 'app-new-vessel',
  templateUrl: './new-vessel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MatInputModule,
    MaterialOrganisationSelectorComponent,
    MatButtonModule,
    MaterialPgInputComponent
  ]
})
export class NewVesselComponent implements OnInit {
  vessel!: Vessel;
  name!: string;
  imo!: string;
  flag!: Organisation;
  flags: Organisation[] = [];
  title = new EventEmitter<string>();

  constructor(private _vesselsServiceSpa: VesselServiceSpa,
    private _router: Router,
    private _organisationService: OrganisationService,
    private _pgMessagesService: PgMessagesService,) { }

  ngOnInit(): void {
    this.title.emit('New Vessel');
    this._organisationService.get().subscribe(x => {
      this.flags = x.filter(z => z.properties['country'] === true);
    });
  }

  addVessel() {
    this.vessel = Vessel.create({
      imo: this.imo,
      name: {
        name: this.name,
        flag: this.flag.name,
        from: new Date().getTime(),
      },
      active: false
    });
    this.saveVessel();
  }

  saveVessel() {
    this._vesselsServiceSpa.addVessel(this.vessel).then(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        topic: 'Vessel',
        message: `The Vessel ${this.vessel.imo} added to list`
      });
      this._router
        .navigate([
          'vessels/vessel/',
          this.vessel.imo
        ])
        .then();
    }).catch(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Error,
        topic: 'Vessel',
        message: 'There was a problem to add this vessel'
      });
    });
  }

}
